// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610131205/js/" + chunkId + "." + {"44":"cfca1127","225":"366b70da","481":"f7d97c52","486":"74843e2d","770":"79376965"}[chunkId] + ".0.5260292517061614.chunk.js";
};